import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Auth, Hub } from 'aws-amplify';
import { IAppState } from 'src/store';
import { authActions } from 'src/redux/authRedux';
// import { Permission } from 'src/redux/authRedux/types';
import { History } from 'history';
import { TokenService } from 'src/services';
import { commonActions } from 'src/redux/commonRedux';
import { useComponentDidMount } from 'src/hooks';
import { contentActions } from 'src/redux/contentRedux';
import { usersActions } from 'src/redux/usersRedux';

const AuthContainer: React.FC<Props> = ({
  history,
  isAuthenticated,
  onSetAuth,
  onSetSidebar,
  onGetCurrentProfile,
  getUserRoles,
  setUserRoles,
}) => {
  useEffect(() => {
    Hub.listen('auth', authLogin);

    return () => {
      Hub.remove('auth', authLogin);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleGetContent = () => {
    getUserRoles(getUserRolesSuccess, error => console.log(error));
  };

  const getUserRolesSuccess = (response: any) => {
    setUserRoles(response);
  };

  const authLogin = (res: { payload: { event: string; data?: any } }) => {
    const { payload } = res;
    const { event } = payload;
    switch (event) {
      case 'signIn':
        authenticate();
        break;
      case 'signOut':
        console.log('SignOut Catch');
        TokenService.clearToken();
        clearAuth();
        break;
      case 'signIn_failure':
        console.log('signin error', payload?.data?.message);
        break;
      default:
        break;
    }
  };

  const setAuth = (user: any) => {
    !isAuthenticated &&
      onSetAuth({
        isAuthenticated: true,
        user: {
          email: user?.attributes?.email,
          emailVerified: !!user?.attributes?.email_verified,
          firstName: user?.attributes?.given_name,
          lastName: user?.attributes?.family_name,
        },
      });
  };

  const clearAuth = () => {
    onSetAuth({ isAuthenticated: false, user: null });
  };

  // =========================== Didmount ===========================
  useComponentDidMount(() => {
    // 1.call this first when mount because history listen fire when route changed
    authenticate();

    const unlisten = history.listen(() => {
      Auth.currentAuthenticatedUser()
        .then(user => {
          setAuth(user);
        })
        .catch(() => {
          clearAuth();
        });
    });

    return () => {
      unlisten();
    };
  });

  const authenticate = () => {
    // 2. Get current user
    Auth.currentAuthenticatedUser()
      .then(user => {
        onGetCurrentProfile(
          res => {
            if (res.role && res.role === 'ADMIN') {
              onSetSidebar(true);
              setAuth(user);
              handleGetContent();
            } else {
              signOut();
            }
          },
          err => {
            console.log(err);
            signOut();
          },
        );
      })
      .catch(() => signOut());
  };
  const signOut = () => {
    clearAuth();
    localStorage.clear();
    Auth.signOut();
  };
  return null;
};
type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & { history: History };

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
  isAuthenticated: state.auth.isAuthenticated,
});

const mapDispatchToProps = {
  onSetAuth: authActions.setAuth,
  onGetPermission: authActions.getPermission,
  onSetPermissions: authActions.setPermissions,
  onSetSidebar: commonActions.setSidebar,
  onExchangeToken: authActions.exchangeToken,
  setUserTypes: contentActions.setUserTypes,
  getUserRoles: contentActions.getUserRoles,
  setUserRoles: contentActions.setUserRoles,
  onGetCurrentProfile: usersActions.getCurrentProfile,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthContainer));
